import { render, staticRenderFns } from "./report-edit-detail.vue?vue&type=template&id=23492f9d&scoped=true"
import script from "./report-edit-detail.vue?vue&type=script&lang=js"
export * from "./report-edit-detail.vue?vue&type=script&lang=js"
import style0 from "./report-edit-detail.vue?vue&type=style&index=0&id=23492f9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23492f9d",
  null
  
)

export default component.exports